import { Injectable } from '@angular/core';
import { InMemoryHttpClient } from './in-memory-http-client';
import { Observable } from 'rxjs';
import { RequestInfo, ResponseOptions, STATUS } from 'angular-in-memory-web-api';
import { UserActivityResponse } from '../../../interfaces/response/UserResponses';

/**
 * This service intercepts {@link UserActivityService} requests and redirects them to an in-memory data store.
 */
@Injectable({
  providedIn: 'root'
})
export class InMemoryUserActivityDataService implements InMemoryHttpClient {

  /** User activity test data. */
  userActivity: UserActivityResponse[] = [
    { date: '2021-10-01', emailAddress: 'user1' },
    { date: '2021-10-01', emailAddress: 'user2' },
    { date: '2021-10-01', emailAddress: 'user3' },
    { date: '2021-10-02', emailAddress: 'user4' },
    { date: '2021-10-03', emailAddress: 'user1' },
    { date: '2021-10-04', emailAddress: 'user1' },
    { date: '2021-10-04', emailAddress: 'user2' },
    { date: '2021-10-05', emailAddress: 'user3' },
  ];

  /**
   * Intercepts HTTP DELETE request of {@link UserActivityService}.
   * @param reqInfo information about the current HTTP DELETE request.
   */
  delete(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP GET request of {@link UserActivityService}. Gets all required records from an in-memory data store.
   * @param reqInfo information about the current HTTP GET request.
   */
  get(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return reqInfo.utils.createResponse$(() => {
        return {
          body: this.userActivity,
          status: STATUS.OK
        };
      }
    );
  }

  /**
   * Intercepts HTTP POST request of {@link UserActivityService}.
   * @param reqInfo information about the current HTTP POST request.
   */
  post(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP PUT request of {@link UserActivityService}.
   * @param reqInfo information about the current HTTP PUT request.
   */
  put(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP PATCH request of {@link UserActivityService}.
   * @param reqInfo information about the current HTTP PATCH request.
   */
  patch(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }
}
